import { ItemType, Order, Product } from "@jasper/shared";
import {
  HooksAndOptionsMappedValues,
  ProsthesisMappedValues,
  InformationMappedValues,
  savePartialDenture,
} from "./savePartialDenture.utils";

export type PatientFormValues = Record<string, unknown> & {
  doctorId: string;
  firstName: string;
  lastName: string;
  birthDate: number;
  sex: string;
};

export const updatePatient = async (
  updateOrder: (data: { variables: any }) => Promise<Order>,
  mappedValues: PatientFormValues,
  orderId: string
) => {
  try {
    return await updateOrder({
      variables: {
        data: {
          user: {
            connect: {
              id: mappedValues.doctorId,
            },
          },
          patient: {
            create: {
              firstName: mappedValues.firstName,
              lastName: mappedValues.lastName,
              birthdate: mappedValues.birthDate,
              sex: mappedValues.sex,
              dentist: {
                connect: {
                  id: mappedValues.doctorId,
                },
              },
            },
          },
        },
        where: {
          id: orderId,
        },
      },
    });
  } catch (error) {
    console.error("Failed to update patient:", error);
    throw error;
  }
};

export const updateProduct = async (
  updateOrder: (data: { variables: any }) => Promise<Order>,
  mappedValues:
    | InformationMappedValues
    | ProsthesisMappedValues
    | HooksAndOptionsMappedValues,
  orderId: string,
  refetchOrder: () => Promise<Order>,
  currentProduct: ItemType,
  currentStepLabel: string,
  product: Product
) => {
  try {
    switch (currentProduct) {
      case ItemType.PARTIAL_DENTURE:
        savePartialDenture(
          updateOrder,
          mappedValues,
          orderId,
          refetchOrder,
          currentStepLabel,
          product
        );
        break;
      default:
        console.warn(
          `Product type "${currentProduct}" not handled for product update.`
        );
    }
  } catch (error) {
    console.error("Failed to update product:", error);
    throw error;
  }
};
